import { getCurrencyProps } from './get-currency-props';

export function getCurrency() {
  return getCurrencyProps().currency;
}
